$(function() {
  'use strict';
  const BaseModule = require('_base/base');

  class Marginal extends BaseModule {
    preInit() {
      this.OVERLAP_HEIGHT = 31;
      this.THRESHOLD = 75;

      this.isFinal = true;
    }

    postInit() {
      const $page = this.$el.closest('.js__page');

      this.$neighbor = this.$el.next();
      if (!this.$neighbor.length) this.$neighbor = this.$el.parent();

      if (!$page.hasClass('is__sticky')) {
        const side = $page.hasClass('page_left') ? 'Left' : 'Right';

        this.overlapClass = `is__overlapped${side}`;
        this.isOverlapping = false;

        this.$spread.on('spreadMove', this.checkOverlap.bind(this));
      }
    }

    postReset() {
      this.$el.css('top', 'auto');
    }

    postCalculate() {
      this.$parent = this.findOffsetParent(this.$el);

      this.offset = this.$neighbor.offset().top - this.spread.triggers.hold;

      const height = this.$el[0].getBoundingClientRect().height;

      this.parentOffset = this.$parent.offset().top - this.spread.triggers.hold;
      this.triggerIn = this.offset - this.spread._book.cellHeight - this.OVERLAP_HEIGHT;

      this.speed = this.spread.speed || 1;

      if (this.triggerIn < 0) {
        this.triggerIn = 0;
      }

      this.triggerOut = this.triggerIn + height + this.OVERLAP_HEIGHT + this.THRESHOLD;
    }

    postRender() {
      this.$el.css('top', this.offset - this.parentOffset);
    }

    findOffsetParent($el) {
      const $parent = $el.parent();

      if ($parent.css('position') === 'static') {
        return this.findOffsetParent($parent);
      }
      return $parent;
    }

    checkOverlap(_, data) {
      const position = data.originalPosition * this.speed;

      if (position > this.triggerIn && position < this.triggerOut) {
        this.isOverlapping = true;
        this.$spread.addClass(this.overlapClass);
      } else if (this.isOverlapping) {
        this.isOverlapping = false;
        this.$spread.removeClass(this.overlapClass);
      }
    }
  }

  $('.js__marginal').each(function() {
    new Marginal($(this));
  });
});
